import { useCallback, useMemo } from 'react';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';
import type { ShareChannel } from 'src/app/pages/psf/share/shared/types';
import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useCurrentUserId } from 'src/app/shared/hooks/session';
import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

export function useGetShareTrackingData(): ShareActionsOptions<ShareChannel>['getTrackingData'] {
	const userId = useCurrentUserId();
	const sourceLocation = useQueryParamValue('source_location');
	const {
		data: {
			initial,
			petition: { id, user, photo },
		},
	} = usePsfSharePageData();

	const commonTrackingData = useMemo(
		() => ({
			context: initial ? 'psf_combo_share_initial' : 'psf_combo_share_message',
			view_context: initial ? 'psf_combo_share_initial' : 'psf_combo_share_message',
			source_location: sourceLocation,
			petition_id: `petition_${id}`,
			own_petition: userId === user.id,
			showImage: !!photo,
		}),
		[sourceLocation, id, userId, user.id, initial, photo],
	);

	return useCallback(
		(_channel: ShareChannel) => {
			switch (_channel) {
				default:
					return commonTrackingData;
			}
		},
		[commonTrackingData],
	);
}
